// Tạo từ Barem khóa mới ver 1_10 cần đẩy live.xlsx.
export const evaluationTemplatesV3 = {
  "BasicSpeaking": {
    "label": "Basic Speaking",
    "items": [
      {
        "key": "fluencyCoherence",
        "label": "Fluency & Coherence",
        "items": [
          {
            "key": "fluencyCoherence",
            "label": "Fluency & Coherence",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể trả lời một số câu hỏi quen thuộc bằng từ, cụm từ hoặc câu ngắn.<br />Câu trả lời thường chỉ gồm một từ, cụm từ hoặc câu rất ngắn, chưa tạo thành câu trả lời hoàn chỉnh.<br />Học viên thường khó duy trì câu trả lời quá một câu hoặc gặp nhiều khoảng dừng khi cố gắng nói thêm thông tin.<br />Các câu trả lời thường rời rạc và chưa thể hiện khả năng kết nối các thông tin đơn giản.",
                "score": 0.5
              },
              {
                "comment": "Có thể trả lời các câu hỏi quen thuộc bằng những câu đơn cơ bản.<br />Có thể cung cấp một hoặc hai thông tin đơn giản liên quan đến câu hỏi, chẳng hạn như sở thích, thời gian, địa điểm, người hoặc hoạt động.<br />Câu trả lời thường vẫn ngắn và dựa vào các mẫu câu quen thuộc, nhưng nhìn chung có thể truyền tải đầy đủ thông tin chính.<br />Một số ngập ngừng, nói lặp, hoặc tự sửa lỗi có thể xuất hiện, miễn là không làm ảnh hưởng đáng kể đến việc hiểu câu trả lời.",
                "score": 1.5
              },
              {
                "comment": "Có thể trả lời các câu hỏi quen thuộc một cách rõ ràng và tương đối trôi chảy.<br />Có thể cung cấp một hoặc hai thông tin đơn giản liên quan đến câu hỏi, chẳng hạn như sở thích, thời gian, địa điểm, người hoặc hoạt động.<br />Có thể kết hợp các câu đơn giản để tạo thành một câu trả lời ngắn và có mạch ý rõ ràng.<br />Một số ngập ngừng, nói lặp, hoặc tự sửa lỗi có thể xuất hiện, miễn là không làm ảnh hưởng đáng kể đến việc hiểu câu trả lời.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "lexicalResource",
        "label": "Lexical Resource",
        "items": [
          {
            "key": "lexicalResource",
            "label": "Lexical Resource",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể sử dụng một số từ và cụm từ rất cơ bản liên quan đến các chủ đề quen thuộc.<br />Vốn từ còn hạn chế, khiến học viên thường chỉ sử dụng một số từ quen thuộc để trả lời và khó bổ sung thêm thông tin.<br />Học viên thường phải lặp lại cùng một từ hoặc sử dụng những từ rất chung như good, nice, thing, like để diễn đạt nhiều ý khác nhau.<br />Việc sử dụng từ sai nghĩa có thể khiến một số câu trả lời khó hiểu.",
                "score": 0.5
              },
              {
                "comment": "Có thể sử dụng các từ và cụm từ quen thuộc phù hợp với những chủ đề đã học để trả lời câu hỏi.<br />Có thể sử dụng vocabulary cơ bản để nói về người, vật, hoạt động, sở thích, thói quen và trải nghiệm quen thuộc.<br />Vocabulary có thể còn đơn giản và một số từ có thể được lặp lại, nhưng học viên vẫn có đủ từ để truyền tải rõ thông tin mình muốn nói.<br />Một vài lỗi về word choice vẫn có thể xuất hiện nếu không ảnh hưởng đáng kể đến ý nghĩa của câu trả lời.",
                "score": 1.5
              },
              {
                "comment": "Có thể sử dụng các từ và cụm từ quen thuộc chính xác và phù hợp để trả lời câu hỏi.<br />Có thể chủ động lựa chọn một số từ cụ thể hơn để mô tả người, vật, hoạt động, sở thích hoặc trải nghiệm.<br />Nếu một số từ được lặp lại nhưng học viên vẫn sử dụng đúng nghĩa và phù hợp với ngữ cảnh sẽ không ảnh hưởng đến điểm số<br />Nếu học viên thường xuyên dùng từ sai nghĩa hoặc dùng từ không phù hợp đến mức ảnh hưởng đến việc truyền tải ý, tiêu chí chỉ nên ở mức 1.5.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "grammaticalRangeAccuracy",
        "label": "Grammatical Range & Accuracy",
        "items": [
          {
            "key": "grammaticalRangeAccuracy",
            "label": "Grammatical Range & Accuracy",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Sử dụng một số cấu trúc ngữ pháp cơ bản để trả lời các câu hỏi quen thuộc.<br />Câu trả lời thường chứa lỗi ngay trong những cấu trúc cơ bản như be, have, subject–verb agreement, pronouns hoặc word order.<br />Lỗi xuất hiện thường xuyên khiến nhiều câu không hoàn chỉnh hoặc làm người nghe khó hiểu ý của học viên.<br />Học viên chủ yếu sử dụng các cụm từ hoặc mẫu câu rời rạc thay vì tạo được câu hoàn chỉnh một cách ổn định.",
                "score": 0.5
              },
              {
                "comment": "Có thể sử dụng các cấu trúc ngữ pháp cơ bản đã học để tạo câu hoàn chỉnh và trả lời các câu hỏi quen thuộc.<br />Có thể sử dụng những cấu trúc phù hợp để nói về bản thân, gia đình, sở thích, thói quen, khả năng, hoạt động và những thông tin quen thuộc.<br />Một số lỗi ngữ pháp vẫn có thể xuất hiện, đặc biệt khi học viên nói dài hơn, nhưng phần lớn câu vẫn đúng cấu trúc và truyền tải rõ ý.<br />Không cần giảm điểm chỉ vì học viên chủ yếu sử dụng câu đơn; câu đơn chính xác và phù hợp với trình độ A1 là đủ để đạt chuẩn.",
                "score": 1.5
              },
              {
                "comment": "Có thể sử dụng các cấu trúc ngữ pháp A1 chính xác và ổn định để trả lời các câu hỏi quen thuộc.<br />Có thể kết hợp các cấu trúc đã học để cung cấp thêm thông tin, chẳng hạn như sử dụng and, but, because, so hoặc các cấu trúc về thời gian, tần suất, khả năng và thói quen khi phù hợp.<br />Một vài lỗi nhỏ có thể chấp nhận nếu không xuất hiện thường xuyên và không ảnh hưởng đến ý nghĩa của câu trả lời.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "pronunciation",
        "label": "Pronunciation",
        "items": [
          {
            "key": "pronunciation",
            "label": "Pronunciation",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể phát âm một số từ và câu quen thuộc trong bài.<br />Lỗi phát âm ở individual sounds và word stress xuất hiện khá thường xuyên, khiến một số từ khó nhận diện và câu trả lời đôi khi khó hiểu.<br />Sentence stress và rhythm chưa ổn định, đặc biệt khi học viên nói câu dài hơn.",
                "score": 0.5
              },
              {
                "comment": "Có thể phát âm phần lớn các từ và câu quen thuộc đủ rõ để truyền tải nội dung.<br />Có thể phát âm tương đối chính xác các âm và trọng âm trong những từ quen thuộc đã học.<br />Một số lỗi về individual sounds, word stress hoặc sentence stress vẫn có thể xuất hiện, nhưng nhìn chung không ảnh hưởng đáng kể đến việc hiểu câu trả lời.",
                "score": 1.5
              },
              {
                "comment": "Có thể phát âm các từ và câu quen thuộc rõ ràng và tương đối ổn định.<br />Có thể kiểm soát khá tốt individual sounds và word stress, đồng thời sử dụng sentence stress và rhythm ở mức cơ bản để làm rõ câu trả lời.<br />Một vài lỗi nhỏ về âm, trọng âm hoặc nhịp điệu vẫn có thể xuất hiện nhưng không ảnh hưởng đến khả năng hiểu câu trả lời.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      }
    ]
  },
  "BasicWriting": {
    "label": "Basic Writing",
    "items": [
      {
        "key": "taskResponse",
        "label": "Task Response",
        "items": [
          {
            "key": "taskResponse",
            "label": "Task Response",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể viết một số nội dung liên quan đến chủ đề được yêu cầu.<br />Nội dung còn hạn chế hoặc chưa tập trung rõ vào yêu cầu của đề, khiến người đọc chưa có được bức tranh rõ ràng về chủ đề.<br />Bài viết có thể chưa đạt độ dài tối thiểu 80 từ hoặc chưa có đủ nội dung để thể hiện rõ chủ đề đã giao.",
                "score": 0.5
              },
              {
                "comment": "Có thể viết một đoạn văn đúng chủ đề và cung cấp các thông tin cơ bản liên quan đến yêu cầu của đề.<br />Có thể sử dụng các gợi ý trong đề hoặc tự lựa chọn thông tin khác, miễn là thông tin đó phù hợp với topic.<br />Có thể phát triển một số ý bằng cách thêm thông tin đơn giản, nhưng mức độ phát triển chưa sâu hoặc chưa đồng đều.<br />Người đọc có thể hiểu rõ học viên đang muốn nói gì về chủ đề, dù một số thông tin có thể chưa thực sự cần thiết hoặc chưa hỗ trợ trực tiếp cho ý chính.",
                "score": 1.5
              },
              {
                "comment": "Có thể viết một đoạn văn tập trung rõ vào topic và phát triển nội dung bằng các thông tin phù hợp.<br />Có thể chủ động lựa chọn, kết hợp và phát triển thông tin từ gợi ý của đề hoặc tự đưa ra ý tưởng phù hợp.<br />Các thông tin được thêm vào có chức năng làm rõ, giải thích, mô tả hoặc mở rộng nội dung chính, thay vì chỉ thêm thông tin để làm bài dài hơn.<br />Không cần đề cập tất cả các gợi ý; bài viết vẫn có thể đạt mức này nếu một số khía cạnh được lựa chọn và phát triển đầy đủ.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "coherenceCohesion",
        "label": "Coherence & Cohesion",
        "items": [
          {
            "key": "coherenceCohesion",
            "label": "Coherence & Cohesion",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể viết các câu liên quan đến chủ đề.<br />Các câu chủ yếu đứng riêng lẻ hoặc được sắp xếp mà chưa thể hiện rõ mối liên hệ giữa các ý.<br />Có thể sử dụng một số từ chỉ thời gian hoặc từ nối quen thuộc, nhưng việc liên kết các câu còn hạn chế.<br />Đoạn văn có thể chuyển từ ý này sang ý khác khá đột ngột hoặc lặp lại cùng một thông tin, khiến người đọc khó theo dõi mạch nội dung.",
                "score": 0.5
              },
              {
                "comment": "Có thể sắp xếp các câu theo một trình tự đơn giản để người đọc theo dõi được nội dung.<br />Có thể sử dụng các từ nối quen thuộc như and, but, because, so, then để liên kết các câu và ý.<br />Các câu nhìn chung đều liên quan đến chủ đề, nhưng chủ yếu cung cấp các thông tin riêng lẻ và mối liên hệ giữa các câu còn đơn giản.",
                "score": 1.5
              },
              {
                "comment": "Có thể sắp xếp các câu thành một đoạn văn có trình tự rõ ràng và dễ theo dõi.<br />Có thể sử dụng các từ nối quen thuộc để thể hiện những mối quan hệ đơn giản giữa các ý.<br />Các câu có mối quan hệ nội dung rõ ràng, trong đó thông tin sau bổ sung, giải thích hoặc phát triển thông tin trước để cùng phát triển một nội dung thống nhất.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "lexicalResource",
        "label": "Lexical Resource",
        "items": [
          {
            "key": "lexicalResource",
            "label": "Lexical Resource",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể sử dụng một số từ và cụm từ cơ bản liên quan đến chủ đề.<br />Vốn từ còn hạn chế, thường phải lặp lại cùng một số từ hoặc dùng từ rất chung để diễn đạt nhiều nội dung khác nhau.<br />Có lỗi dùng từ khiến người đọc khó hiểu hoặc không xác định rõ ý.<br />Bài viết dưới độ dài tối thiểu cũng không được đánh giá trên mức 0.5 vì chưa cung cấp đủ ngôn ngữ để đánh giá vốn từ một cách đầy đủ.",
                "score": 0.5
              },
              {
                "comment": "Có thể sử dụng các từ và cụm từ quen thuộc phù hợp với chủ đề để diễn đạt nội dung cơ bản.<br />Có đủ từ để mô tả người, vật, hoạt động, địa điểm, thời gian, sở thích hoặc cảm xúc trong phạm vi chủ đề.<br />Từ vựng có thể còn đơn giản và lặp lại, nhưng nhìn chung đủ để truyền tải rõ nội dung.<br />Một vài lỗi dùng từ vẫn có thể xuất hiện nếu không làm thay đổi hoặc cản trở việc hiểu ý.",
                "score": 1.5
              },
              {
                "comment": "Có thể sử dụng các từ và cụm từ quen thuộc chính xác và phù hợp để diễn đạt nội dung.<br />Có thể sử dụng từ cụ thể thay cho từ quá chung chung khi mô tả người, vật, hoạt động, địa điểm, thời gian, sở thích hoặc cảm xúc.<br />Có thể kết hợp các từ khác nhau để diễn đạt cùng một nội dung mà không phụ thuộc quá nhiều vào một từ hoặc cụm từ.<br />Lỗi dùng từ nếu có không ảnh hưởng đến ý nghĩa của đoạn văn.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "grammaticalRangeAccuracy",
        "label": "Grammatical Range & Accuracy",
        "items": [
          {
            "key": "grammaticalRangeAccuracy",
            "label": "Grammatical Range & Accuracy",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể sử dụng các cấu trúc ngữ pháp cơ bản để viết về những chủ đề quen thuộc.<br />Việc tạo câu và sử dụng các cấu trúc đã học chưa ổn định; lỗi về cấu trúc câu, dạng động từ, be hoặc chia động từ xuất hiện thường xuyên.<br />Các lỗi này có thể khiến một số câu chưa rõ nghĩa hoặc chưa hoàn chỉnh.",
                "score": 0.5
              },
              {
                "comment": "Có thể sử dụng các cấu trúc ngữ pháp cơ bản để viết về những chủ đề quen thuộc.<br />Có thể tạo câu hoàn chỉnh và sử dụng các cấu trúc đã học để diễn đạt thông tin về bản thân, gia đình, sở thích, thói quen và các hoạt động quen thuộc.<br />Lỗi về cấu trúc câu, dạng động từ, be hoặc chia động từ vẫn xuất hiện, nhưng phần lớn câu vẫn rõ nghĩa.",
                "score": 1.5
              },
              {
                "comment": "Có thể sử dụng các cấu trúc ngữ pháp cơ bản để viết về những chủ đề quen thuộc.<br />Có thể tạo và kết hợp các câu sử dụng những cấu trúc đã học để diễn đạt nhiều loại thông tin khác nhau về bản thân, gia đình, sở thích, thói quen và các hoạt động quen thuộc.<br />Các cấu trúc đã học được sử dụng chính xác trong phần lớn đoạn văn; lỗi về cấu trúc câu, dạng động từ, be hoặc chia động từ chỉ xuất hiện không thường xuyên.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      }
    ]
  },
  "PiSpeaking": {
    "label": "Pre IELTS Speaking",
    "items": [
      {
        "key": "fluencyCoherence",
        "label": "Fluency & Coherence",
        "items": [
          {
            "key": "fluencyCoherence",
            "label": "Fluency & Coherence",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể trả lời hoặc nói về chủ đề nhưng thường chỉ sử dụng từ, cụm từ hoặc câu rất ngắn.<br />Khó duy trì câu trả lời và thường dừng lại sau một ý đơn giản.<br />Các câu thường rời rạc, khiến người nghe khó theo dõi mạch ý.<br />Có nhiều sự ngập ngừng và nói lặp khi cố gắng nói thêm.",
                "score": 0.5
              },
              {
                "comment": "Có thể trả lời trực tiếp và cung cấp thêm thông tin đơn giản liên quan đến câu hỏi.<br />Có thể kết nối các câu đơn giản để tạo thành một câu trả lời ngắn và dễ theo dõi.<br />Có thể duy trì câu trả lời ở mức cơ bản, nhưng vẫn có một số khoảng dừng hoặc lặp lại.<br />Đôi khi cần thời gian để tiếp tục nói hoặc chuyển sang thông tin tiếp theo.",
                "score": 1.5
              },
              {
                "comment": "Có thể trả lời rõ ràng và cung cấp đủ thông tin đơn giản để hoàn thành câu trả lời.<br />Có thể kết nối các câu đơn giản thành một mạch ý rõ ràng và dễ theo dõi.<br />Có thể duy trì việc nói tương đối ổn định khi trình bày các ý quen thuộc.<br />sự ngập ngừng và nói lặp vẫn có thể xuất hiện, nhưng không làm gián đoạn đáng kể câu trả lời.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "lexicalResource",
        "label": "Lexical Resource",
        "items": [
          {
            "key": "lexicalResource",
            "label": "Lexical Resource",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể sử dụng từ vựng để diễn đạt một số thông tin rất cơ bản, nhưng thường gặp khó khăn khi muốn nói thêm.<br />Thường lặp lại cùng một từ hoặc cụm từ để diễn đạt các ý khác nhau.<br />Có nhiều trường hợp lựa chọn hoặc sử dụng từ chưa phù hợp, khiến một số ý khó hiểu.<br />Có nhiều lỗi về dạng từ hoặc kết hợp từ, ảnh hưởng đến khả năng truyền đạt.",
                "score": 0.5
              },
              {
                "comment": "Có thể sử dụng vốn từ đủ để diễn đạt các ý cơ bản về những chủ đề quen thuộc.<br />Có thể sử dụng một số cách diễn đạt khác nhau, nhưng vẫn còn lặp từ khi cần nói dài hơn.<br />Phần lớn từ được sử dụng phù hợp với ý muốn diễn đạt, dù đôi khi vẫn có lỗi dùng từ hoặc kết hợp từ.<br />Các lỗi về dạng từ hoặc kết hợp từ thường không ảnh hưởng đến việc hiểu ý.",
                "score": 1.5
              },
              {
                "comment": "Có thể sử dụng vốn từ đủ để diễn đạt rõ ràng các ý cơ bản về những chủ đề quen thuộc.<br />Có thể lựa chọn từ phù hợp với ý muốn diễn đạt và thay đổi cách diễn đạt khi cần.<br />Có thể sử dụng từ vựng để bổ sung thông tin và làm rõ câu trả lời mà không bị hạn chế đáng kể bởi vốn từ.<br />Cách dùng từ nhìn chung chính xác; các lỗi nếu có không gây khó khăn đáng kể cho việc hiểu ý.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "grammaticalRangeAccuracy",
        "label": "Grammatical Range & Accuracy",
        "items": [
          {
            "key": "grammaticalRangeAccuracy",
            "label": "Grammatical Range & Accuracy",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Chủ yếu sử dụng các cấu trúc câu rất đơn giản và thường lặp lại cùng một dạng câu.<br />Có nhiều lỗi về cấu trúc câu, chia động từ, thì hoặc trật tự từ.<br />Khó kết hợp các câu để diễn đạt nhiều thông tin trong cùng một câu.<br />Lỗi ngữ pháp xuất hiện thường xuyên và có thể khiến người nghe khó hiểu ý.",
                "score": 0.5
              },
              {
                "comment": "Có thể sử dụng câu đơn và một số câu kết hợp đơn giản để diễn đạt các ý cơ bản.<br />Các cấu trúc quen thuộc thường được sử dụng đúng, nhưng vẫn có lỗi khi nói câu dài hơn.<br />Có thể kết hợp các câu để thêm thông tin hoặc giải thích đơn giản.<br />Lỗi ngữ pháp vẫn xuất hiện nhưng thường không ảnh hưởng đến việc hiểu ý.",
                "score": 1.5
              },
              {
                "comment": "Có thể sử dụng câu đơn và các cấu trúc kết hợp quen thuộc một cách khá ổn định.<br />Có thể kết hợp các câu để diễn đạt nhiều thông tin liên quan trong một câu trả lời.<br />Kiểm soát tốt các cấu trúc ngữ pháp quen thuộc ở mức A2.<br />Vẫn có thể mắc lỗi, nhưng lỗi không gây khó khăn đáng kể cho việc hiểu ý.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "pronunciation",
        "label": "Pronunciation",
        "items": [
          {
            "key": "pronunciation",
            "label": "Pronunciation",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Người nghe khó hiểu nhiều từ và câu, ngay cả khi học viên nói về những nội dung quen thuộc.<br />Cách phát âm chưa đủ rõ để người nghe nhận diện ổn định các từ được sử dụng.<br />Trọng âm từ và nhịp điệu câu chưa rõ, khiến việc theo dõi nội dung gặp nhiều khó khăn.",
                "score": 0.5
              },
              {
                "comment": "Người nghe có thể hiểu được phần lớn nội dung cơ bản mà học viên muốn truyền đạt.<br />Phần lớn từ được phát âm đủ rõ để người nghe nhận diện, dù độ rõ chưa hoàn toàn ổn định.<br />Trọng âm từ và nhịp điệu câu có thể hỗ trợ việc hiểu nội dung, nhưng chưa được duy trì ổn định trong toàn bộ bài nói.",
                "score": 1.5
              },
              {
                "comment": "Người nghe có thể dễ dàng hiểu nội dung học viên muốn truyền đạt.<br />Các từ và câu được phát âm rõ ràng và tương đối ổn định.<br />Trọng âm từ và nhịp điệu câu hỗ trợ tốt việc nhận diện từ và theo dõi nội dung.<br />Có thể vẫn có lỗi phát âm, nhưng không gây khó khăn đáng kể cho người nghe.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      }
    ]
  },
  "PiWriting": {
    "label": "Pre IELTS Writing",
    "items": [
      {
        "key": "taskResponse",
        "label": "Task Response",
        "items": [
          {
            "key": "taskResponse",
            "label": "Task Response",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể viết về chủ đề quen thuộc và đưa ra một số thông tin liên quan.<br />Nội dung còn hạn chế, với một số ý chính được nêu nhưng chưa được làm rõ hoặc phát triển thêm.<br />Bài viết có thể bỏ sót một số khía cạnh quan trọng của chủ đề hoặc chuyển sang những thông tin chưa thực sự liên quan.",
                "score": 0.5
              },
              {
                "comment": "Có thể viết đúng chủ đề và cung cấp các thông tin phù hợp để làm rõ nội dung.<br />Có thể phát triển một số ý bằng chi tiết, lý do, ví dụ hoặc thông tin cá nhân đơn giản.<br />Nội dung nhìn chung đáp ứng được yêu cầu của đề, nhưng một số ý vẫn được phát triển khá ngắn hoặc chưa được làm rõ đầy đủ.",
                "score": 1.5
              },
              {
                "comment": "Có thể viết tập trung vào đúng chủ đề và cung cấp các thông tin phù hợp để phát triển nội dung.<br />Có thể làm rõ các ý bằng những chi tiết, lý do, ví dụ hoặc thông tin cá nhân cụ thể, giúp người đọc hiểu rõ hơn về chủ đề.<br />Các ý chính được phát triển tương đối đầy đủ và không phụ thuộc vào việc phải sử dụng tất cả các gợi ý trong đề.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "coherenceCohesion",
        "label": "Coherence & Cohesion",
        "items": [
          {
            "key": "coherenceCohesion",
            "label": "Coherence & Cohesion",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể viết các câu liên quan đến chủ đề.<br />Các câu chủ yếu đứng riêng lẻ hoặc được sắp xếp mà chưa thể hiện rõ mối liên hệ giữa các ý.<br />Có thể sử dụng một số từ chỉ thời gian hoặc từ nối quen thuộc, nhưng việc liên kết các câu còn hạn chế.<br />Đoạn văn có thể chuyển từ ý này sang ý khác khá đột ngột hoặc lặp lại cùng một thông tin, khiến người đọc khó theo dõi mạch nội dung.",
                "score": 0.5
              },
              {
                "comment": "Có thể sắp xếp các câu theo một trình tự đơn giản để người đọc theo dõi được nội dung.<br />Có thể sử dụng các từ nối quen thuộc như and, but, because, so, then để liên kết các câu và ý.<br />Các câu nhìn chung có liên quan đến nhau, nhưng mối liên hệ giữa một số câu vẫn còn đơn giản và chủ yếu dựa vào việc nối các thông tin bằng các từ nối cơ bản.",
                "score": 1.5
              },
              {
                "comment": "Có thể sắp xếp các câu thành một đoạn văn có trình tự rõ ràng và dễ theo dõi.<br />Có thể sử dụng các từ nối quen thuộc như and, but, because, so, then, after that để thể hiện những mối quan hệ đơn giản giữa các ý, chẳng hạn như bổ sung, tương phản, nguyên nhân hoặc trình tự thời gian.<br />Các câu có mối liên hệ rõ ràng với nhau và cùng phát triển chủ đề thay vì chỉ được đặt cạnh nhau như những câu thông tin riêng biệt.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "lexicalResource",
        "label": "Lexical Resource",
        "items": [
          {
            "key": "lexicalResource",
            "label": "Lexical Resource",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể sử dụng một số từ và cụm từ cơ bản liên quan đến chủ đề.<br />Vốn từ còn hạn chế, khiến học viên thường phải lặp lại cùng một số từ hoặc sử dụng những từ rất chung để diễn đạt nhiều nội dung khác nhau.<br />Một số lỗi dùng từ có thể khiến người đọc khó hiểu hoặc không xác định được chính xác ý mà học viên muốn diễn đạt.",
                "score": 0.5
              },
              {
                "comment": "Có thể sử dụng các từ và cụm từ quen thuộc phù hợp với chủ đề để diễn đạt những nội dung cơ bản.<br />Có thể sử dụng vocabulary liên quan đến các nội dung quen thuộc như hoạt động, người, địa điểm, thời gian, sở thích và cảm xúc.<br />Vocabulary có thể còn đơn giản và lặp lại, nhưng nhìn chung học viên có đủ từ để diễn đạt rõ nội dung của đoạn văn.<br />Một vài lỗi dùng từ vẫn có thể xuất hiện nếu không làm thay đổi hoặc cản trở việc hiểu ý.",
                "score": 1.5
              },
              {
                "comment": "Có thể sử dụng các từ và cụm từ quen thuộc, chính xác và phù hợp để diễn đạt nội dung của đoạn văn.<br />Có thể lựa chọn những từ cụ thể hơn khi mô tả hoạt động, người, địa điểm, thời gian, sở thích hoặc cảm xúc.<br />Lỗi dùng từ chỉ xuất hiện không thường xuyên và không ảnh hưởng đến ý nghĩa của đoạn văn.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "grammaticalRangeAccuracy",
        "label": "Grammatical Range & Accuracy",
        "items": [
          {
            "key": "grammaticalRangeAccuracy",
            "label": "Grammatical Range & Accuracy",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể sử dụng các cấu trúc ngữ pháp cơ bản để viết về những chủ đề quen thuộc.<br />Việc tạo câu và sử dụng các cấu trúc đã học chưa ổn định; lỗi về cấu trúc câu, dạng động từ, be hoặc chia động từ xuất hiện thường xuyên.<br />Các lỗi này có thể khiến một số câu chưa rõ nghĩa hoặc chưa hoàn chỉnh.",
                "score": 0.5
              },
              {
                "comment": "Có thể sử dụng các cấu trúc ngữ pháp cơ bản để viết về những chủ đề quen thuộc.<br />Có thể tạo câu hoàn chỉnh và sử dụng các cấu trúc đã học để diễn đạt thông tin về đặc điểm, thói quen, hoạt động, trải nghiệm, lý do và cảm nhận cá nhân.<br />Lỗi về cấu trúc câu, dạng động từ, be hoặc chia động từ vẫn xuất hiện, nhưng phần lớn câu vẫn rõ nghĩa.",
                "score": 1.5
              },
              {
                "comment": "Có thể sử dụng các cấu trúc ngữ pháp cơ bản để viết về những chủ đề quen thuộc.<br />Có thể tạo và kết hợp các câu sử dụng những cấu trúc đã học đặc điểm, hoạt động, trải nghiệm, lý do và cảm nhận cá nhân.<br />Các cấu trúc đã học được sử dụng chính xác trong phần lớn đoạn văn; lỗi về cấu trúc câu, dạng động từ, be hoặc chia động từ chỉ xuất hiện không thường xuyên.<br />Nếu có sử dụng cấu trúc nâng cao cần phải được dùng đúng form, các trường hợp có sử dụng nhưng sử dụng sai nhiều, ảnh hưởng đến độ hiểu sẽ bị giới hạn ở mức 1.5 điểm",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      }
    ]
  },
  "FoundationSpeaking": {
    "label": "IELTS 3.5-4.5 Speaking",
    "items": [
      {
        "key": "fluencyCoherence",
        "label": "Fluency & Coherence",
        "items": [
          {
            "key": "fluencyCoherence",
            "label": "Fluency & Coherence",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể truyền đạt một số ý cơ bản về chủ đề được hỏi, nhưng câu trả lời thường ngắn và chưa được phát triển.<br />Có thể đưa ra một ý nhưng khó duy trì hoặc mở rộng ý đó bằng thông tin liên quan.<br />Các câu và ý thường rời rạc, chưa tạo thành một mạch nói rõ ràng.<br />Nếu có nói được dài hơn nhưng bài nói có nhiều ngập ngừng, nói lặp hoặc tự sửa lỗi thì điểm vẫn sẽ bị giới hạn ở thang này.",
                "score": 0.5
              },
              {
                "comment": "Có thể trả lời trực tiếp và truyền đạt các ý chính liên quan đến chủ đề.<br />Có thể thêm một số thông tin liên quan, nhưng khả năng phát triển và duy trì ý còn hạn chế.<br />Có thể kết nối các câu đơn giản, nhưng mạch ý đôi khi bị gián đoạn hoặc chuyển sang ý khác khá đột ngột.<br />Ngập ngừng, nói lặp hoặc tự sửa lỗi xuất hiện khá thường xuyên khi học viên cố gắng nói dài hơn.",
                "score": 1
              },
              {
                "comment": "Có thể trả lời trực tiếp và phát triển ý bằng explanation, example, reason hoặc thông tin liên quan.<br />Có thể kết nối các câu để tạo thành một mạch ý tương đối rõ ràng.<br />Có thể duy trì và phát triển câu trả lời, nhưng đôi khi vẫn gặp khó khăn khi cần nói dài hơn hoặc phát triển ý sâu hơn.<br />Ngập ngừng, nói lặp hoặc tự sửa lỗi vẫn xuất hiện nhưng thường không làm gián đoạn đáng kể việc truyền đạt ý.",
                "score": 1.5
              },
              {
                "comment": "Có thể trả lời trực tiếp và phát triển các ý một cách tương đối tự nhiên bằng explanation, example, reason hoặc thông tin hỗ trợ.<br />Có thể kết nối các câu và ý theo một trình tự hợp lý, giúp người nghe dễ theo dõi nội dung.<br />Có thể duy trì mạch nói tương đối ổn định và tiếp tục phát triển ý thay vì dừng lại sau khi đưa ra Main Idea.<br />Ngập ngừng, nói lặp hoặc tự sửa lỗi vẫn xuất hiện nhưng thường không làm gián đoạn đáng kể việc truyền đạt ý.",
                "score": 2
              },
              {
                "comment": "Có thể trả lời, duy trì và phát triển ý một cách rõ ràng trong toàn bộ bài nói.<br />Có thể sử dụng explanation, example, reason và các thông tin hỗ trợ khác để làm rõ hoặc mở rộng ý thay vì chỉ lặp lại ý đã nói.<br />Có thể kết nối các câu và ý thành một mạch nói rõ ràng, hợp lý và tương đối tự nhiên.<br />Ngập ngừng, nói lặp hoặc tự sửa lỗi vẫn xuất hiện nhưng thường không làm gián đoạn đáng kể việc truyền đạt ý.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "lexicalResource",
        "label": "Lexical Resource",
        "items": [
          {
            "key": "lexicalResource",
            "label": "Lexical Resource",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Vốn từ còn hạn chế, nên học viên gặp khó khăn khi diễn đạt các ý ngoài những nội dung rất quen thuộc.<br />Thường sử dụng các từ/cụm từ rất chung hoặc lặp lại cùng một cách diễn đạt để truyền tải nhiều ý khác nhau.<br />Có nhiều lỗi dùng từ trong đó một số lỗi làm thay đổi hoặc gây khó hiểu ý muốn diễn đạt.<br />Có nhiều lỗi về dạng từ hoặc cách sử dụng từ, khiến việc diễn đạt bị hạn chế.",
                "score": 0.5
              },
              {
                "comment": "Có thể sử dụng vốn từ cơ bản để trả lời và phát triển các ý liên quan đến chủ đề.<br />Có thể diễn đạt được nội dung chính, nhưng gặp khó khăn khi cần mô tả cụ thể hơn hoặc mở rộng ý.<br />Có thể thay đổi cách diễn đạt ở một số trường hợp, nhưng vẫn lặp lại từ/cụm từ khá thường xuyên.<br />Có lỗi dùng từ, hoặc dạng từ, nhưng phần lớn ý vẫn có thể hiểu được.",
                "score": 1
              },
              {
                "comment": "Có thể sử dụng vốn từ đủ để diễn đạt và phát triển các ý chính trong bài nói.<br />Có thể lựa chọn từ phù hợp với ý muốn diễn đạt và sử dụng một số cách diễn đạt khác nhau.<br />Vẫn có sự lặp lại hoặc phụ thuộc vào một số cách diễn đạt quen thuộc, đặc biệt khi phát triển ý dài hơn.<br />Có một số lỗi dùng từ, kết hợp từ hoặc dạng từ, nhưng thường không ảnh hưởng đáng kể đến việc truyền đạt ý.",
                "score": 1.5
              },
              {
                "comment": "Có thể sử dụng vốn từ đủ để diễn đạt rõ ràng và phát triển các ý trong các chủ đề khác nhau.<br />Có thể lựa chọn từ/cụm từ phù hợp để mô tả, giải thích, đưa ví dụ và thể hiện quan điểm.<br />Có thể thay đổi cách diễn đạt khi cần, hạn chế sự lặp lại không cần thiết.<br />Phần lớn từ và cụm từ được sử dụng đúng nghĩa và phù hợp với ngữ cảnh.<br />Có thể còn một số lỗi về dùng từ, kết hợp từ hoặc dạng từ, nhưng không ảnh hưởng đáng kể đến việc hiểu ý.",
                "score": 2
              },
              {
                "comment": "Có thể sử dụng vốn từ đủ rộng và linh hoạt để diễn đạt, phát triển và làm rõ các ý trong toàn bộ bài nói.<br />Có thể lựa chọn từ/cụm từ phù hợp với ý muốn diễn đạt và thay đổi cách diễn đạt một cách tự nhiên khi cần.<br />Có thể sử dụng từ vựng để mô tả, giải thích, đưa ví dụ, so sánh và thể hiện quan điểm mà không bị hạn chế đáng kể bởi vốn từ.<br />Có thể còn một số lỗi về dùng từ, kết hợp từ hoặc dạng từ, nhưng không ảnh hưởng đáng kể đến việc hiểu ý.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "grammaticalRangeAccuracy",
        "label": "Grammatical Range & Accuracy",
        "items": [
          {
            "key": "grammaticalRangeAccuracy",
            "label": "Grammatical Range & Accuracy",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Chủ yếu sử dụng các cấu trúc câu đơn giản và lặp lại một số dạng câu quen thuộc.<br />Có nhiều lỗi về cấu trúc câu, chia động từ, thì hoặc subject-verb agreement.<br />Khi cố gắng sử dụng cấu trúc dài hoặc phức tạp hơn, lỗi xuất hiện thường xuyên.<br />Một số lỗi làm người nghe khó hiểu hoặc hiểu sai ý.",
                "score": 0.5
              },
              {
                "comment": "Có thể sử dụng câu đơn và một số câu có cấu trúc kết hợp đơn giản để diễn đạt ý.<br />Có thể sử dụng các cấu trúc ngữ pháp quen thuộc, nhưng chưa kiểm soát ổn định.<br />Lỗi xuất hiện khá thường xuyên, đặc biệt khi học viên cố gắng nói dài hơn hoặc sử dụng cấu trúc phức tạp hơn.<br />Phần lớn ý vẫn có thể hiểu được, dù một số câu có lỗi rõ ràng.",
                "score": 1
              },
              {
                "comment": "Có thể sử dụng câu đơn và một số câu ghép/câu phức quen thuộc để diễn đạt và phát triển ý.<br />Các cấu trúc quen thuộc thường được sử dụng đúng, nhưng độ chính xác giảm khi câu trở nên dài hoặc phức tạp hơn.<br />Có thể cố gắng sử dụng cấu trúc phức tạp hơn, nhưng vẫn còn lỗi.<br />Lỗi ngữ pháp thường không ảnh hưởng đáng kể đến việc hiểu ý chính.",
                "score": 1.5
              },
              {
                "comment": "Có thể sử dụng và kết hợp nhiều dạng cấu trúc câu để diễn đạt và phát triển ý.<br />Có thể sử dụng các cấu trúc phức tạp hơn một cách tương đối hiệu quả.<br />Phần lớn cấu trúc ngữ pháp được sử dụng chính xác, bao gồm thì, dạng động từ, subject-verb agreement và cấu trúc câu.<br />Có thể vẫn mắc lỗi khi sử dụng cấu trúc phức tạp hơn, nhưng lỗi không ảnh hưởng đáng kể đến việc truyền đạt ý.",
                "score": 2
              },
              {
                "comment": "Có thể sử dụng và kết hợp nhiều dạng cấu trúc câu một cách linh hoạt khi diễn đạt và phát triển ý.<br />Có thể sử dụng các cấu trúc phức tạp hơn tương đối chính xác và phù hợp với ý muốn diễn đạt.<br />Kiểm soát tốt các cấu trúc quen thuộc và duy trì độ chính xác khi phát triển câu trả lời.<br />Lỗi ngữ pháp nếu có không thường xuyên và hiếm khi ảnh hưởng đến việc hiểu ý.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "pronunciation",
        "label": "Pronunciation",
        "items": [
          {
            "key": "pronunciation",
            "label": "Pronunciation",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Phát âm còn nhiều lỗi khiến một số từ hoặc câu khó nhận ra.<br />Có nhiều lỗi về âm, trọng âm từ hoặc nhịp điệu.<br />Người nghe thường phải cố gắng để hiểu nội dung.",
                "score": 0.5
              },
              {
                "comment": "Có thể phát âm đủ rõ để truyền đạt phần lớn nội dung, nhưng một số từ hoặc câu còn khó hiểu.<br />Có lỗi về âm và trọng âm từ, đặc biệt khi nói nhanh hoặc nói câu dài.<br />Nhịp điệu và trọng âm câu còn chưa ổn định nhưng thường không cản trở hoàn toàn việc hiểu ý.",
                "score": 1
              },
              {
                "comment": "Phần lớn nội dung có thể được hiểu mà không cần người nghe phải cố gắng nhiều.<br />Các âm và trọng âm từ nhìn chung có thể nhận ra, nhưng vẫn có một số lỗi lặp lại.<br />Trọng âm câu và nhịp điệu còn chưa ổn định, đặc biệt khi phát triển câu trả lời dài hơn.<br />Một số lỗi phát âm có thể làm người nghe phải chú ý hơn nhưng thường không ảnh hưởng đáng kể đến ý chính.",
                "score": 1.5
              },
              {
                "comment": "Phát âm nhìn chung rõ ràng và dễ hiểu trong toàn bộ bài nói.<br />Phần lớn các âm và trọng âm từ được phát âm chính xác.<br />Có thể sử dụng trọng âm câu và nhịp điệu để làm rõ những thông tin quan trọng.<br />Vẫn có một số lỗi phát âm, nhưng hiếm khi gây khó khăn cho việc hiểu nội dung.",
                "score": 2
              },
              {
                "comment": "Phát âm rõ ràng và dễ hiểu một cách ổn định trong toàn bộ bài nói.<br />Các âm và trọng âm từ nhìn chung được kiểm soát tốt.<br />Trọng âm câu và nhịp điệu được sử dụng phù hợp, giúp người nghe dễ theo dõi và hiểu ý.<br />Lỗi phát âm nếu có hiếm khi ảnh hưởng đến khả năng hiểu nội dung.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      }
    ]
  },
  "FoundationWriting": {
    "label": "IELTS 3.5-4.5 Writing Task 1",
    "items": [
      {
        "key": "taskAchievement",
        "label": "Task Achievement",
        "items": [
          {
            "key": "taskAchievement",
            "label": "Task Achievement",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "- Không có Introduction hoặc Introduction không đúng dạng biểu đồ.<br />- Không có Overview hoặc Overview không liên quan đến biểu đồ.<br />- Chỉ viết một vài câu mô tả số liệu rời rạc.<br />- Có nhiều lỗi sai thông tin khiến người đọc hiểu sai biểu đồ.<br />- Bài viết có thể chưa đạt độ dài tối thiểu 150 từ.",
                "score": 0.5
              },
              {
                "comment": "- Có Introduction và có cố gắng viết Overview nhưng Overview còn chung chung.<br />- Có mô tả được một số số liệu chính trong biểu đồ.<br />- Có đề cập đến các nhóm số liệu chính nhưng chưa đầy đủ.<br />- Có một số lỗi về số liệu hoặc xu hướng nhưng người đọc vẫn hiểu được nội dung chính.<br />- Bài viết có thể chưa đạt độ dài tối thiểu 150 từ.",
                "score": 1
              },
              {
                "comment": "- Có đủ Introduction + Overview + Body.<br />- Overview nêu được ít nhất một đặc điểm chính.<br />- Mô tả được phần lớn nhóm/đối tượng trong biểu đồ.<br />- Có đưa số liệu để minh họa.<br />- Có thể còn: thiếu một vài chi tiết; mô tả hơi giống liệt kê; chưa chọn lọc tốt thông tin.",
                "score": 1.5
              },
              {
                "comment": "- Có Introduction, Overview và các đoạn thân bài rõ ràng.<br />- Overview nêu được các xu hướng chính của biểu đồ.<br />- Mô tả được tất cả nhóm/đối tượng quan trọng.<br />- Có sử dụng số liệu phù hợp để hỗ trợ nhận xét.<br />- Có một số phép so sánh giữa các nhóm.<br />- Có thể còn lỗi nhỏ về cách diễn đạt hoặc bỏ qua một vài chi tiết nhỏ.",
                "score": 2
              },
              {
                "comment": "- Overview rõ ràng, bao quát được các đặc điểm chính.<br />- Chọn được những thông tin quan trọng nhất thay vì chỉ liệt kê số liệu.<br />- Mô tả đầy đủ các nhóm chính.<br />- Có so sánh giữa các nhóm khi phù hợp.<br />- Số liệu nhìn chung chính xác.<br />- Các lỗi nếu có chỉ là lỗi nhỏ về diễn đạt, không ảnh hưởng nội dung.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "coherenceCohesion",
        "label": "Coherence & Cohesion",
        "items": [
          {
            "key": "coherenceCohesion",
            "label": "Coherence & Cohesion",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "- Không chia đoạn hoặc chia đoạn không hợp lý.<br />- Các câu đứng riêng lẻ, không có sự liên kết giữa các ý.<br />- Ý tưởng sắp xếp lộn xộn khiến người đọc khó theo dõi bài viết.<br />- Hầu như không sử dụng từ nối hoặc sử dụng sai khiến mối quan hệ giữa các ý không rõ ràng.",
                "score": 0.5
              },
              {
                "comment": "- Có cố gắng chia đoạn nhưng bố cục chưa rõ ràng.<br />- Có thể có Introduction/Body nhưng thiếu Overview hoặc các phần chưa được phân chia hợp lý.<br />- Các câu chủ yếu được viết theo dạng liệt kê số liệu, chưa có sự phát triển giữa các ý.<br />- Có sử dụng một vài từ nối cơ bản (e.g. and, but, however) nhưng còn hạn chế hoặc đôi lúc dùng chưa đúng.",
                "score": 1
              },
              {
                "comment": "- Có bố cục cơ bản gồm các đoạn chính của bài Task 1.<br />- Các đoạn nhìn chung có chủ đề rõ ràng.<br />- Thông tin trong bài được sắp xếp tương đối dễ hiểu.<br />- Có sử dụng một số từ nối để thể hiện sự thêm ý, tương phản hoặc thay đổi xu hướng.<br />- Một số câu vẫn còn rời rạc hoặc chuyển ý chưa tự nhiên.",
                "score": 1.5
              },
              {
                "comment": "- Có bố cục rõ ràng với Introduction, Overview và Body được phân chia hợp lý.<br />- Mỗi đoạn tập trung vào một nhóm thông tin chính.<br />- Các ý được sắp xếp theo trình tự hợp lý (theo nhóm đối tượng, thời gian hoặc xu hướng).<br />- Sử dụng được các từ nối phổ biến để kết nối ý, có thể hơi lặp từ (e.g. however, while).<br />- Có thể còn một vài lỗi nhỏ về lặp từ hoặc chuyển ý.",
                "score": 2
              },
              {
                "comment": "- Bố cục rõ ràng, dễ theo dõi từ đầu đến cuối.<br />- Các đoạn được chia hợp lý và có mục đích rõ ràng.<br />- Thông tin được nhóm và triển khai tự nhiên, không bị nhảy ý.<br />- Sử dụng từ nối phù hợp để thể hiện quan hệ giữa các ý, có sự đa dạng, không bị lặp nhiều.<br />- Các lỗi liên kết không đáng kể và không ảnh hưởng đến việc hiểu bài.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "lexicalResource",
        "label": "Lexical Resource",
        "items": [
          {
            "key": "lexicalResource",
            "label": "Lexical Resource",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Vốn từ còn hạn chế, chưa đủ để mô tả các xu hướng, số liệu và so sánh trong toàn bài.<br />Thường phải lặp lại cùng một từ/cụm từ khi mô tả các thông tin khác nhau.<br />Có nhiều lỗi dùng từ hoặc kết hợp từ, trong đó một số lỗi làm thay đổi hoặc gây khó hiểu thông tin được trình bày.<br />Có nhiều lỗi chính tả hoặc dạng từ, và một số lỗi ảnh hưởng đến việc hiểu nội dung.",
                "score": 0.5
              },
              {
                "comment": "Có đủ từ vựng để diễn đạt một phần thông tin trong biểu đồ, nhưng gặp khó khăn khi phải mô tả nhiều xu hướng, thay đổi hoặc so sánh.<br />Có thể thay đổi cách diễn đạt ở một số trường hợp, nhưng vẫn lặp lại nhiều từ/cụm từ trong bài.<br />Có lỗi dùng từ hoặc kết hợp từ, trong đó một số lỗi khiến cách diễn đạt chưa chính xác.<br />Có lỗi chính tả hoặc dạng từ, nhưng phần lớn nội dung vẫn có thể hiểu được.",
                "score": 1
              },
              {
                "comment": "Có đủ từ vựng để diễn đạt các thông tin chính về xu hướng, số liệu, thay đổi và so sánh.<br />Có thể sử dụng các cách diễn đạt khác nhau ở một số phần, nhưng vẫn còn repetition khi trình bày các thông tin tương tự.<br />Có thể lựa chọn từ phù hợp với ý muốn diễn đạt, nhưng đôi khi dùng từ hoặc kết hợp từ chưa chính xác.<br />Có lỗi chính tả hoặc dạng từ, nhưng thường không làm thay đổi thông tin chính.",
                "score": 1.5
              },
              {
                "comment": "Có đủ từ vựng để diễn đạt các xu hướng, mức độ thay đổi và sự so sánh được thể hiện trong biểu đồ.<br />Có thể thay đổi cách diễn đạt khi trình bày các thông tin tương tự, hạn chế repetition không cần thiết.<br />Phần lớn từ và cụm từ được sử dụng đúng nghĩa và phù hợp với thông tin cần diễn đạt.<br />Có thể còn một số lỗi về dùng từ, kết hợp từ, chính tả hoặc dạng từ, nhưng không làm sai thông tin chính.",
                "score": 2
              },
              {
                "comment": "Có đủ vốn từ để diễn đạt rõ ràng và chính xác các thông tin, xu hướng, mức độ thay đổi và sự so sánh trong biểu đồ.<br />Có thể linh hoạt thay đổi cách diễn đạt khi trình bày các thông tin tương tự, thay vì phụ thuộc vào một cách diễn đạt duy nhất.<br />Có thể lựa chọn từ và cụm từ chính xác với ý muốn diễn đạt và thông tin trong biểu đồ.<br />Lỗi về dùng từ, kết hợp từ, chính tả hoặc dạng từ nếu có không làm sai hoặc gây hiểu nhầm thông tin được trình bày.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "grammaticalRangeAndAccuracy",
        "label": "Grammatical Range and Accuracy",
        "items": [
          {
            "key": "grammaticalRangeAndAccuracy",
            "label": "Grammatical Range and Accuracy",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Chủ yếu sử dụng một dạng câu đơn lặp lại, khó kết hợp các thông tin trong cùng một câu.<br />Có nhiều lỗi về cấu trúc câu, chia động từ, thì hoặc subject–verb agreement.<br />Khi sử dụng câu ghép hoặc câu phức, nhiều cấu trúc bị sai hoặc không hoàn chỉnh.<br />Lỗi xuất hiện thường xuyên và một số lỗi làm người đọc khó hiểu hoặc hiểu sai thông tin.",
                "score": 0.5
              },
              {
                "comment": "Có thể sử dụng câu đơn và một số câu được kết hợp bằng các cấu trúc quen thuộc, nhưng phạm vi cấu trúc còn hạn chế.<br />Có lỗi về cấu trúc câu, chia động từ, thì hoặc subject–verb agreement, đặc biệt khi viết câu dài hơn.<br />Có thể cố gắng sử dụng câu ghép/câu phức, nhưng chưa kiểm soát ổn định các cấu trúc này.<br />Lỗi xuất hiện khá thường xuyên, nhưng phần lớn nội dung vẫn có thể hiểu được.",
                "score": 1
              },
              {
                "comment": "Có thể sử dụng câu đơn và một số câu ghép/câu phức quen thuộc để diễn đạt thông tin.<br />Có thể kết hợp các mệnh đề để trình bày nguyên nhân, sự tương phản, thời gian hoặc mối quan hệ giữa các thông tin.<br />Các cấu trúc quen thuộc thường được sử dụng đúng, nhưng vẫn có lỗi khi viết câu dài hoặc sử dụng cấu trúc phức tạp hơn.<br />Lỗi ngữ pháp xuất hiện nhưng thường không làm thay đổi thông tin chính của bài.",
                "score": 1.5
              },
              {
                "comment": "Có thể sử dụng nhiều dạng câu khác nhau để mô tả và so sánh thông tin trong biểu đồ.<br />Có thể sử dụng câu ghép/câu phức để kết hợp các thông tin có liên quan, thay vì chỉ viết các câu đơn riêng biệt.<br />Phần lớn các cấu trúc ngữ pháp được sử dụng chính xác, bao gồm thì, dạng động từ, subject–verb agreement và cấu trúc câu.<br />Có thể còn một số lỗi khi sử dụng cấu trúc phức tạp hơn, nhưng lỗi không làm sai hoặc gây hiểu nhầm thông tin chính.",
                "score": 2
              },
              {
                "comment": "Có thể sử dụng và kết hợp nhiều dạng cấu trúc câu một cách phù hợp để trình bày các thông tin trong biểu đồ.<br />Có thể sử dụng câu ghép/câu phức để kết hợp, so sánh hoặc thể hiện mối quan hệ giữa các thông tin một cách rõ ràng.<br />Kiểm soát tốt các cấu trúc ngữ pháp quen thuộc và duy trì độ chính xác khi viết các câu dài hơn.<br />Lỗi ngữ pháp nếu có không thường xuyên và không làm sai hoặc gây hiểu nhầm thông tin được trình bày.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      }
    ]
  },
  "FoundationWriting2": {
    "label": "IELTS 3.5-4.5 Writing Task 2",
    "items": [
      {
        "key": "taskAchievement",
        "label": "Task Achievement",
        "items": [
          {
            "key": "taskAchievement",
            "label": "Task Achievement",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể đưa ra Position, nhưng position có thể chưa rõ hoặc chưa trả lời trực tiếp câu hỏi.<br />Có thể đưa ra Main Idea, nhưng ý còn chung chung hoặc chỉ mới nêu ra mà chưa giải thích và đưa ra ví dụ.<br />Các ý hỗ trợ có thể chỉ lặp lại Main Idea bằng cách diễn đạt khác thay vì bổ sung thông tin mới.<br />Bài viết có thể chưa đạt độ dài tối thiểu 180 từ.",
                "score": 0.5
              },
              {
                "comment": "Có Position và có thể trả lời trực tiếp câu hỏi, nhưng position chưa được duy trì hoàn toàn rõ ràng trong bài.<br />Có thể đưa ra một hoặc hai Main Ideas phù hợp với position.<br />Có cố gắng đưa ra Explanation hoặc Example, nhưng phần phát triển thường ngắn hoặc chưa làm rõ đầy đủ Main Idea.<br />Bài viết có thể chưa đạt độ dài tối thiểu 180 từ.",
                "score": 1
              },
              {
                "comment": "Có thể đưa ra các Main Ideas phù hợp với Position rõ ràng.<br />Có thể phát triển Main Idea bằng Explanation và/hoặc Example đơn giản.<br />Explanation hoặc Example có bổ sung thông tin mới, nhưng phần phát triển có thể còn ngắn hoặc chưa làm rõ.<br />Có thể thêm các ý hỗ trợ như Result, Consequence hoặc thông tin cụ thể, nhưng chưa phải Main Idea nào cũng được phát triển đầy đủ.",
                "score": 1.5
              },
              {
                "comment": "Có thể đưa ra các Main Ideas trực tiếp hỗ trợ Position rõ ràng.<br />Mỗi Main Idea chính đều có ít nhất một phần Explanation hoặc Example để làm rõ.<br />Explanation giải thích được why/how của Main Idea, thay vì chỉ diễn đạt lại Main Idea.<br />Example hoặc supporting detail cung cấp thông tin cụ thể để minh họa cho Explanation/Main Idea.",
                "score": 2
              },
              {
                "comment": "Có thể đưa ra các Main Ideas trực tiếp hỗ trợ Position rõ ràng.<br />Explanation giải thích được why/how của Main Idea, thay vì chỉ diễn đạt lại Main Idea.<br />Example hoặc supporting detail cung cấp thông tin cụ thể để minh họa cho Explanation/Main Idea.<br />Có thể sử dụng thêm Result/Consequence hoặc các supporting ideas khác khi phù hợp để hoàn thiện mạch phát triển.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "coherenceCohesion",
        "label": "Coherence & Cohesion",
        "items": [
          {
            "key": "coherenceCohesion",
            "label": "Coherence & Cohesion",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Có thể chia bài thành các đoạn, nhưng các ý trong từng đoạn chưa được tổ chức rõ ràng.<br />Các câu thường được đặt cạnh nhau nhưng sự liên hệ giữa chúng chưa rõ, khiến người đọc khó theo dõi. <br />Có sử dụng một số từ nối, nhưng chưa thể hiện rõ mối quan hệ giữa các câu hoặc ý.<br />Bài viết chưa tạo được một mạch lập luận rõ ràng từ đầu đến cuối.",
                "score": 0.5
              },
              {
                "comment": "Có thể chia bài thành các đoạn cơ bản, nhưng cách sắp xếp ý trong một số đoạn chưa hợp lý.<br />Có thể trình bày các câu theo một trình tự đơn giản, nhưng đôi khi chuyển từ ý này sang ý khác khá đột ngột.<br />Có sử dụng các từ nối cơ bản để kết nối câu, nhưng có thể lặp lại hoặc sử dụng chưa đúng mối quan hệ giữa các ý.<br />Người đọc có thể hiểu được mạch chính, nhưng phải tự liên kết một số câu và ý với nhau.",
                "score": 1
              },
              {
                "comment": "Có thể sắp xếp các ý thành các đoạn phù hợp và duy trì một trình tự tương đối dễ theo dõi.<br />Các câu trong cùng một đoạn nhìn chung có liên quan và cùng phát triển một ý.<br />Có thể sử dụng các từ nối quen thuộc để thể hiện bổ sung, nguyên nhân, kết quả hoặc tương phản.<br />Một số chuyển ý hoặc mối liên hệ giữa các câu chưa thật rõ, nhưng nhìn chung người đọc vẫn theo dõi được lập luận.",
                "score": 1.5
              },
              {
                "comment": "Có thể tổ chức bài thành các đoạn với chức năng tương đối rõ ràng.<br />Các ý được sắp xếp theo một trình tự hợp lý.<br />Có thể sử dụng các phương tiện liên kết để thể hiện rõ mối quan hệ giữa các câu và ý.<br />Mạch lập luận nhìn chung rõ ràng, dù một số liên kết hoặc chuyển ý vẫn có thể còn đơn giản.",
                "score": 2
              },
              {
                "comment": "Có thể tổ chức bài thành các đoạn rõ ràng và phù hợp với sự phát triển của lập luận.<br />Các câu và ý được sắp xếp theo trình tự logic, giúp người đọc dễ theo dõi.<br />Có thể sử dụng các phương tiện liên kết đúng chức năng để kết nối các câu và ý, thay vì chỉ thêm từ nối vào đầu câu.<br />Bài viết duy trì được một mạch lập luận rõ ràng từ đầu đến cuối; các câu trong mỗi đoạn đều đóng góp vào việc phát triển ý chính của đoạn.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "lexicalResource",
        "label": "Lexical Resource",
        "items": [
          {
            "key": "lexicalResource",
            "label": "Lexical Resource",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Vốn từ còn hạn chế, nên học viên gặp khó khăn khi diễn đạt các ý chính trong bài.<br />Thường sử dụng các từ rất chung hoặc lặp lại các từ/cụm từ quen thuộc để diễn đạt nhiều ý khác nhau.<br />Có nhiều lỗi dùng từ hoặc kết hợp từ, trong đó một số lỗi làm thay đổi hoặc gây khó hiểu ý nghĩa câu.<br />Có nhiều lỗi chính tả hoặc dạng từ, và một số lỗi ảnh hưởng đến khả năng hiểu bài viết.",
                "score": 0.5
              },
              {
                "comment": "Có thể sử dụng một số từ/cụm từ để diễn đạt quan điểm, lý do và ví dụ đơn giản.<br />Thường lặp lại các từ quen thuộc và ít thay đổi cách diễn đạt.<br />Có lỗi dùng từ, kết hợp từ, chính tả hoặc dạng từ, nhưng phần lớn nội dung vẫn có thể hiểu được.<br />Một số cách diễn đạt còn chung chung, chưa thể hiện rõ ý muốn trình bày.",
                "score": 1
              },
              {
                "comment": "Có thể sử dụng từ vựng phù hợp để trình bày quan điểm, lý do và phát triển các ý cơ bản.<br />Có thể sử dụng một số cách diễn đạt khác nhau để tránh lặp lại hoàn toàn cùng một từ/cụm từ.<br />Có thể lựa chọn từ phù hợp với nội dung muốn nói, nhưng đôi khi vẫn có lỗi về cách kết hợp từ hoặc sử dụng từ chưa chính xác.<br />Một số từ/cụm từ còn mang tính chung chung, khiến phần giải thích hoặc ví dụ chưa thật cụ thể.<br />Có lỗi chính tả hoặc dạng từ, nhưng thường không ảnh hưởng đến việc hiểu ý chính.",
                "score": 1.5
              },
              {
                "comment": "Có thể sử dụng vốn từ phù hợp để diễn đạt rõ quan điểm, lý do, giải thích và ví dụ trong bài.<br />Có thể lựa chọn từ/cụm từ phù hợp với từng ý thay vì chỉ sử dụng những cách diễn đạt chung chung.<br />Có thể thay đổi cách diễn đạt ở một số phần để hạn chế repetition không cần thiết.<br />Phần lớn từ vựng được sử dụng đúng nghĩa và phù hợp với ngữ cảnh.<br />Có thể còn một số lỗi về dùng từ, kết hợp từ, chính tả hoặc dạng từ, nhưng không làm thay đổi ý nghĩa chính của bài.",
                "score": 2
              },
              {
                "comment": "Có thể sử dụng vốn từ đủ rộng để diễn đạt rõ ràng các ý chính, lý do, giải thích và ví dụ trong bài.<br />Có thể lựa chọn cách diễn đạt phù hợp để làm rõ ý tưởng, thay vì chỉ sử dụng những từ/cụm từ quen thuộc.<br />Có thể linh hoạt thay đổi cách diễn đạt khi phát triển các ý khác nhau.<br />Sử dụng từ vựng nhìn chung chính xác và phù hợp với nội dung bài viết.<br />Lỗi về dùng từ, kết hợp từ, chính tả hoặc dạng từ nếu có không gây hiểu nhầm hoặc ảnh hưởng đến cách người đọc hiểu lập luận.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      },
      {
        "key": "grammaticalRangeAccuracy",
        "label": "Grammatical Range & Accuracy",
        "items": [
          {
            "key": "grammaticalRangeAccuracy",
            "label": "Grammatical Range & Accuracy",
            "comment_auto": "",
            "criterion_score": "",
            "items": [
              {
                "comment": "Chủ yếu sử dụng các câu đơn với cấu trúc lặp lại và gặp khó khăn khi kết hợp nhiều thông tin trong một câu.<br />Có nhiều lỗi về cấu trúc câu, dạng động từ, thì, subject–verb agreement hoặc cách sử dụng từ loại.<br />Khi cố gắng sử dụng câu dài hơn hoặc câu ghép/câu phức, nhiều cấu trúc bị sai hoặc không hoàn chỉnh.<br />Lỗi xuất hiện thường xuyên và một số lỗi làm thay đổi ý nghĩa hoặc khiến người đọc khó hiểu nội dung.",
                "score": 0.5
              },
              {
                "comment": "Có thể sử dụng câu đơn và một số câu ghép đơn giản để diễn đạt ý.<br />Có thể sử dụng một số cấu trúc quen thuộc, nhưng phạm vi cấu trúc còn hạn chế.<br />Có lỗi ngữ pháp, đặc biệt khi học viên viết câu dài hơn hoặc cố gắng sử dụng cấu trúc phức tạp hơn.<br />Có thể có một số lỗi lặp lại về thì, dạng động từ hoặc cấu trúc câu, nhưng phần lớn nội dung vẫn có thể hiểu được.",
                "score": 1
              },
              {
                "comment": "Có thể sử dụng câu đơn và một số câu ghép/câu phức quen thuộc để trình bày quan điểm và phát triển ý.<br />Có thể kết hợp các ý bằng các cấu trúc ngữ pháp cơ bản thay vì chỉ viết các câu riêng lẻ.<br />Các cấu trúc quen thuộc thường được sử dụng đúng, nhưng độ chính xác chưa ổn định khi viết những câu dài hơn.<br />Lỗi ngữ pháp vẫn xuất hiện, nhưng thường không ảnh hưởng đến việc hiểu ý chính của bài viết.",
                "score": 1.5
              },
              {
                "comment": "Có thể sử dụng nhiều dạng câu khác nhau để trình bày quan điểm, lý do và ví dụ.<br />Có thể sử dụng câu ghép/câu phức để kết nối các ý có liên quan và phát triển lập luận.<br />Phần lớn các cấu trúc ngữ pháp được sử dụng chính xác.<br />Có thể vẫn có một số lỗi khi sử dụng cấu trúc phức tạp hơn nhưng không ảnh hưởng đến độ hiểu.",
                "score": 2
              },
              {
                "comment": "Có thể sử dụng và kết hợp nhiều dạng cấu trúc câu để diễn đạt quan điểm, giải thích và đưa ví dụ.<br />Có thể sử dụng câu ghép/câu phức một cách phù hợp để thể hiện mối quan hệ giữa các ý.<br />Kiểm soát tốt các cấu trúc ngữ pháp quen thuộc và duy trì độ chính xác trong toàn bài.<br />Các lỗi ngữ pháp nếu có chỉ xuất hiện không thường xuyên và không ảnh hưởng đến cách người đọc hiểu lập luận.",
                "score": 2.5
              }
            ]
          }
        ],
        "comment_detail": ""
      }
    ]
  }
};

export const BASIC_IELTS_1VS1 = 1795
export const BASIC_IELTS_ONLINE = 1781
export const BASIC_IELTS = 1786
export const BASIC_IELTS_CENTER_516 = 1773
export const PRE_IELTS_1VS1 = 1796
export const PRE_IELTS_ONLINE = 1782
export const PRE_IELTS = 1787
export const PRE_IELTS_CENTER_516 = 1774
export const IELTS_3_5_4_5_1VS1 = 1797
export const IELTS_3_5_4_5 = 1788
export const IELTS_3_5_4_5_CENTER_516 = 1775
export const IELTS_3_5_4_5_ONLINE = 1783
